// extracted by mini-css-extract-plugin
export default {"container":"SimulacaoSalvas_container__TIkKP"};